<script>
    import RequestNumberField from '../RequestNumberField.svelte';
    import { showFiori } from '../diffStore.js';
    import { isStrategyChange } from '../utils.js';

    export let row = {};
</script>

{#if $showFiori && isStrategyChange(row)}
<RequestNumberField bind:governance={row.governance} on:handleChange eevId={row.target == null ? row.source.element_element_version_id : row.target.element_element_version_id} on:checkFiori />
{/if}
